module.exports = __webpack_public_path__ + "static/media/photo-video.e9182954.svg";